// extracted by mini-css-extract-plugin
export default {"progressbar":"Progressbar_progressbar__luePM","progress":"Progressbar_progress__Wmgxk"};